import { PropsWithChildren, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useCurrentUser } from "../hooks/useCurrentUser";

type StaffOnlyProps = PropsWithChildren<{ redirectTo?: string }>;

export function StaffOnly({ redirectTo, children }: StaffOnlyProps) {
  const { isCustomer, isStaff, user } = useCurrentUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (isCustomer) {
      navigate(redirectTo ?? `/o/${user?.UserTenant[0]?.tenantId}`, { replace: true });
    }
  }, [isCustomer, navigate, redirectTo, user?.UserTenant]);

  if (!isStaff) {
    return <></>;
  }

  return <>{children}</>;
}
